import React from 'react'
import BaseIcon from 'react-icon-base'

const ZA = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 9 6" {...props}>
    <title>Flag of South Africa</title>
    <clipPath id="Z">
      <path d="M0,0 4.5,3 0,6" id="X" />
    </clipPath>
    <clipPath id="A">
      <path d="M0,0H9V6H0z" />
    </clipPath>
    <g clipPath="url(#A)">
      <path d="M0,0V6H9V0z" fill="#002395" />
      <path d="M0,0V3H9V0z" fill="#de3831" />
      <g strokeWidth="2" stroke="#fff">
        <path d="M0,0 4.5,3 0,6M4.5,3H9" id="W" />
        <use xlinkHref="#X" stroke="#ffb612" clipPath="url(#Z)" />
      </g>
      <use xlinkHref="#W" fill="none" stroke="#007a4d" strokeWidth="1.2" />
    </g>
  </BaseIcon>
)

export default ZA
